import * as React from 'react';

import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

import { allRolesStatesSelector } from 'selectors/rolesSelectors';
import RoleContext, { IRoleContext } from 'utils/roleContext';

type RoleContextProviderConnectProps = IRoleContext & DefaultConnectProps;
interface RoleContextProviderNonConnectProps {
  children: React.ReactChild;
}

const RoleContextProviderInner: React.FunctionComponent<
  React.PropsWithChildren<RoleContextProviderConnectProps & RoleContextProviderNonConnectProps>
> = (props) => {
  const {
    children,
    hasDriverRole,
    hasHostRole,
    hasEmployeeRole,
    hasAdminRole,
    hasAccountOwnerRole,
    hasHospitalityRole,
    hasFinanceRole,
    hasEngRole,
  } = props;
  return (
    <RoleContext.Provider
      value={{
        hasDriverRole,
        hasHostRole,
        hasEmployeeRole,
        hasAdminRole,
        hasAccountOwnerRole,
        hasHospitalityRole,
        hasFinanceRole,
        hasEngRole,
      }}
    >
      {children}
    </RoleContext.Provider>
  );
};

export default connect<RoleContextProviderNonConnectProps, RoleContextProviderConnectProps>(
  RoleContextProviderInner,
  allRolesStatesSelector
);
